// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_lm-1";
export var quotedThread = "_lm-0";